angular.module('mtic')
.constant('DATA_HOST', {
  C3_TEACHER_CONFIGS: {
    'path': 'https://s3.eu-central-1.amazonaws.com/mtic-human-config/c3-teacher-configs/',
    'ext': '.json'
  }
})
